const try_for_free = "https://portal.requiresign.com/register";
const login = "https://portal.requiresign.com/login";
const register_free = "https://portal.requiresign.com/register?plan=free";
const register_professional =
  "https://portal.requiresign.com/register?plan=professional";
const register_team = "https://portal.requiresign.com/register?plan=team";

const API_URL = "https://server.requiresign.com/";

export {
  try_for_free,
  login,
  register_free,
  register_professional,
  register_team,
  API_URL,
};
